import { render, staticRenderFns } from "./RegisterDorm.vue?vue&type=template&id=c0682952&"
import script from "./RegisterDorm.vue?vue&type=script&lang=js&"
export * from "./RegisterDorm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDorm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegisterDorm.vue"
export default component.exports